import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceHelper } from '../../providers/services/auth.service';
import { USERCATEGORY } from '../../constants/helper-constant';
import { isTabView } from '../../utils';

@Component({
  selector: 'app-login-with-username',
  templateUrl: './login-with-username.component.html',
  styleUrl: './login-with-username.component.scss',
})
export class LoginWithUsernameComponent implements OnInit {
  public signInForm: FormGroup;
  public tenantImage: string | undefined;
  public tenantName: any;
  public avatarInitialCount = 1;
  public avatarSize = 80;
  public submitted: boolean | undefined;
  public tenantId: string | undefined;
  public usernameVal!: string | null;
  public inputType: string = 'password';
  public showPassword: any = false;
  public token!: string;
  public errorMessage!: string;
  public accessToken: any;
  public isTabView: boolean;

  constructor(
    protected formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authServiceHelper: AuthServiceHelper,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.signInForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.isTabView = isTabView();
  }

  // -------------------------------------------------------------------------
  // Events

  ngOnInit() {
    const emailId = localStorage.getItem('tenantEmail');
    this.token = this.activatedRoute.snapshot.queryParams['nonce'];
    this.usernameVal = emailId;
    this.authServiceHelper
      .signInAnonymousUsingNonce(this.token)
      .then(async (data) => {
        this.tenantId = data.tenant.tenantId;
        this.accessToken = data.access_token;
        const tenantSetting = await this.authServiceHelper.tenantsetting(data.access_token);
        this.tenantImage = tenantSetting?.ui_element_visibility_settings?.logo_url;
        this.tenantName = data.tenant?.short_name;
      }).catch(() => {
        this.router.navigate(['login']);
      })
  }

  /**
   * @function goBack
   * this Method is used to navigate back
   */
  public async goBack() {
    const isOnlyOneTenant = await this.checkOnlyOneTenant();
    console.log('isOnlyOnetenant', isOnlyOneTenant);
    if (isOnlyOneTenant) {
      this.router.navigate(['login']);
    } else {
      window.history.back();
    }
  }

  /**
   * @function checkOnlyOneTenant
   * this Method is used to check only one tenant
   */ 
  public async checkOnlyOneTenant(): Promise<boolean> {
    const emailId = localStorage.getItem('tenantEmail') || '';
    return await this.authServiceHelper.accounts(emailId).then((response) => {
      return response.length === 1;
    });
  }

  /**
   * @function login
   * this Method is used to login
   */
  public login() {
    this.submitted = true;
    this.credentialAuthentication(
      this.signInForm.value.username.trim(),
      this.signInForm.value.password,
      this.accessToken
    );
  }

  /**
   * @function validateForm
   * validateForm method used to check the basic form validation
   */
  public get validateForm() {
    return this.signInForm.controls;
  }

  /**
   * @function togglePasswordVisibility
   * this Method is used to toggle password visibility
   */
  public togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.inputType = this.showPassword ? 'text' : 'password';
  }

  /**
   * @function credentialAuthentication
   * this Method is used to authenticate the user
   */
  public credentialAuthentication(
    username: string,
    password: string,
    accessToken: string
  ) {
    this.authServiceHelper
      .signInWithCredential(username, password, accessToken)
      .then(
        async (sessionModel) => {
          if (
            sessionModel &&
            !sessionModel.error
          ) {
            this.router.navigate(['home']);
          } else {
            if (sessionModel && sessionModel.error) {
              this.errorMessage = sessionModel.error.message;
              this.cdr.detectChanges();
            } else if (sessionModel === USERCATEGORY.TEACHER) {
              this.errorMessage =
                'your are using teacher account, please use student account';
            }
          }
        },
        (error) => {
          error.then((error: any) => {
            console.error(error);
          });
        }
      );
  }

  /**
   * @function getInitials
   * this Method is used to get initials of name
   */
  public getInitials(name: string): string {
    if (!name) return '';
    const words = name.trim().split(' ');
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  public forgotPassword() {
    this.router.navigate(['/forgot-password'], {
      queryParams: {
        token: this.accessToken,
        tenantId: this.tenantId,
      },
    });
  }
}
